import { createAsyncThunk } from "@reduxjs/toolkit";
import coreAPIs from "services/api/core";

export const getCoreTags = createAsyncThunk(`core/tags/getTags`, async (payload) => {
  try {
    const response = await coreAPIs.getTags(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const createCoreTag = createAsyncThunk(`core/tags/createTag`, async (payload) => {
  try {
    const response = await coreAPIs.createTags(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data?.error || error;
  }
});

export const updateCoreTag = createAsyncThunk(`core/tags/updateTag`, async (payload, { rejectWithValue }) => {
  try {
    const response = await coreAPIs.updateTags(payload);

    return response.data;
  } catch (error) {
    console.error(error);

    return rejectWithValue(error.response.data);
  }
});

export const getCoreTagsByFieldId = createAsyncThunk(
  `core/tags/getTagsByFieldId`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await coreAPIs.getTagsByFieldId(payload);

      return response.data;
    } catch (error) {
      console.error(error);

      return rejectWithValue(error.response.data);
    }
  },
);
